import { render, staticRenderFns } from "./FeedbackComponent.vue?vue&type=template&id=9d5bac7a&scoped=true"
import script from "./FeedbackComponent.vue?vue&type=script&lang=js"
export * from "./FeedbackComponent.vue?vue&type=script&lang=js"
import style0 from "./FeedbackComponent.vue?vue&type=style&index=0&id=9d5bac7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d5bac7a",
  null
  
)

export default component.exports